import { Controller } from "stimulus";

export default class extends Controller {
  static values = { url: String };

  async save(event) {
    const input = event.target;
    const previous = input.dataset.previous;
    if (input.value === previous) return;

    input.disabled = true;
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ space: { bed_num: input.value === "" ? null : input.value } }),
      });
      if (!response.ok) throw new Error(response.status);
      input.dataset.previous = input.value;
      this.flash(input, "#2e7d32");
    } catch (e) {
      input.value = previous ?? "";
      this.flash(input, "#c62828");
    } finally {
      input.disabled = false;
    }
  }

  flash(input, color) {
    input.style.outline = `2px solid ${color}`;
    setTimeout(() => (input.style.outline = ""), 1200);
  }
}
